import sessionStore from './session.store';
import optionsStore from './options.store';
import filtersStore from './filters.store';
import companyOptionsStore from './companyOptions.store';
import companyStatisticsStore from './companyStatistics.store';

export default { sessionStore, optionsStore, filtersStore, companyOptionsStore, companyStatisticsStore };
